import styled from 'styled-components';

export const Main = styled.main`
	width: 100%;
	min-height: 100vh;
	padding-top: 72px; // The same size as height of header component
`;
